import React from "react";
import { Modal } from "react-bootstrap";
import { Text } from "../../themes/userq/Text/Text";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Button } from "../../themes/userq/Button/Button";

export default function BrowserNotSupportedModal({ openModal, onClose }) {
	return (
		<Modal
			show={openModal}
			centered
			backdrop="static"
			keyboard={false}
			className="fade custom-modal-wrap browser-not-supported-modal"
		>
			<Modal.Body className="p-28">
				<div className="text-center">
					<div className="mb-20 d-flex justify-content-center">
						<Icon
							size={"large"}
							value={"error"}
							colorClass={"danger-200-svg"}
						/>
					</div>
					<Text type={"h3"}>Browser not supported</Text>
					<Text
						type={"body-text-2"}
						fontWeight={"medium-font"}
						cssClasses={"mt-20 gray-text"}
					>
						This study is only available on{" "}
						<span className="semibold-font dark-text">Google Chrome</span> on
						desktop.
					</Text>
					
					<div className="mt-20">
						<Button
							size={"large"}
							type={"primary"}
							label={"Back to dashboard"}
							onClick={onClose}
						/>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
}
